export default axios => ({
  list (page) {
    return axios.get(`tours?page=${page}`)
  },
  create (tour) {
    return axios.post('tour/create', tour)
  },
  get (id) {
    return axios.get(`tour/${id}`)
  },
  edit (id, tour) {
    return axios.patch(`tour/${id}`, tour)
  },
  remove (id) {
    return axios.delete(`tour/${id}`)
  },
  createScene (id, scene) {
    return axios.post(`tour/${id}/scene`, scene)
  },
  sceneImage (tourId, sceneId, file) {
    const formData = new FormData()
    formData.append('image', file, file.name)
    return axios.post(`tour/${tourId}/scene/${sceneId}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  sceneSetDefault (tourId, sceneId, scene) {
    scene.default = true
    return axios.patch(`tour/${tourId}/scene/${sceneId}`, scene)
  },
  sceneEdit (tourId, sceneId, scene) {
    return axios.patch(`tour/${tourId}/scene/${sceneId}`, scene)
  },
  sceneSave (tourId, sceneId, scene) {
    return axios.patch(`tour/${tourId}/scene/${sceneId}`, scene)
  },
  removeScene (tourId, sceneId) {
    return axios.delete(`tour/${tourId}/scene/${sceneId}`)
  }
})
